import React, { useState } from 'react'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { currentPageReportTemplate, onPageChange, paginatorTemplate, rowsPerPageOptions } from '../../../utilities/TableUtil';
import { normalColumn} from '../../../components/DataTable/DataTable.js';
import * as bodyStyle from '../../../components/DataTable/ConsBodyStyle.js';
import { useHistory } from "react-router-dom";

export default function P211List({ dataTable ,columnNo,goPage }) {

    const history = useHistory();
    // console.log('dataTable ----------- ',dataTable);
    // console.log('columnNo ----------- ',columnNo);
    const [pageConf, setPageConf] = useState({ first: 0, rows: 10 });
    // const [globalFilter, setGlobalFilter] = useState(null);
    

    // const header = (
    //     <div className="table-header">
    //         <div>
                
    //         </div>
    //         <span className="p-input-icon-left" >
    //             <i className="pi pi-search" />
    //             <InputText type="search" placeholder="คำค้น" 
    //                 className="btn-responsive"
    //                 onInput={(e) => setGlobalFilter(e.target.value)}
    //             />
    //         </span>
    //     </div>
    // );

    const renderColumnNo = () =>{
        let tmp = []
        for(let key in columnNo){
            tmp.push(
                {
                    id : key,
                    label : columnNo[key]
                }
            )
        }

        return tmp.map((item,index)=>{
            // let styleCol = index === 1?`,width : 8% `:``;
            let styleCol = {
                textAlign: 'center',
            }
            if(index === 0){
                styleCol ={
                    ...styleCol,
                    width : '8%'
                }
            }else if(index === 1){
                styleCol ={
                    ...styleCol,
                    width : '20%'
                }
            }

            return (<Column 
                sortable={index <= 1}
                field={item.id}
                header={item.label} 
                body={(e) => normalColumn(e, item.id, item.label)} 
                style={styleCol}
                bodyStyle={bodyStyle.TXT_CENTER_OVER} 
             />
            )
        })

    }

    return (
        <>
            <div className="datatable-responsive-modify">
                <div className="card">
                    <DataTable
                        // ref={(el) => dt = el} 
                        value={dataTable}
                        dataKey="id"
                        paginator
                        first={pageConf.first}
                        rows={pageConf.rows} 
                        onPage={(e)=>onPageChange(e,setPageConf)}
                        rowsPerPageOptions={rowsPerPageOptions()}
                        paginatorTemplate={paginatorTemplate()}
                        currentPageReportTemplate={currentPageReportTemplate()}
                        // header={header}
                        // globalFilter={globalFilter}
                        emptyMessage="ไม่พบข้อมูลที่ค้นหา"
                        className="p-datatable-gridlines p-datatable-sm p-datatable-responsive-modify"
                        selectionMode="single"
                        
                    >
                        {renderColumnNo()}
                    </DataTable>

                </div>
            </div>

            <div className="p-col-12 p-md-12">
                <div className="p-grid" style={{ textAlign: "center" }}>
                    <div className="p-col-12">
                        <Button
                            className="p-button-secondary p-button btn-long-responsive"
                            icon="pi pi-arrow-left"
                            label="กลับหน้าจอแสดงรายการ"
                            // style={{ marginLeft: '5px' }}
                            style={{ width: 250,marginLeft: "5px", marginTop:'10px' }}
                            onClick={()=> history.push("/208")}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
